export default "__VITE_ASSET__GKFVz6Kn__"